
import BucketCircle from "../../../assets/duotone/BucketCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BucketCircleIcon({ className, dataTestid = "BucketCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BucketCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
